<template>
  <div class="expressionbox">
    <van-swipe class="my-swipe" ref="uploadswip" indicator-color="white" :loop="false" @change="emjoytabClick">
      <van-swipe-item v-for="item in emjoylist" :key="item.id">
        <div class="expression_listbox">
          <div class="expression_list" v-for="item in item.list" :key="item.id" @touchstart="emjoyGtouchstart(item)"
            @touchend="emjoyDeleteButton(item)" @click="emjoyClickButton(item)">
            <img class="expression_list_img" :src="item.src" />
            <div class="expression_list_name">{{ item.name }}</div>
            <div class="expression_list_gif" v-show="expressionTip.id == item.id">
              <img class="" :src="expressionTip.gifSrc" />
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="expression_tab">
      <div class="expression_tablistbox">
        <div class="expression_tablist" v-for="item in emjoytab" :key="item.id"
          :class="item.id == curemjoy ? 'expression_tablistcur' : ''" @click="emjoytabClick(item.id)">
          <img :src="item.src" />
        </div>
      </div>
      <div class="expression_tab_delete" @click="deleteClick"></div>
    </div>
  </div>
</template>
<script>
import emjoydata from "../../utils/emjoydata";
export default {
  name: "emjoy",
  data() {
    return {
      emjoylist: [],
      emjoytab: [],
      expressionTip: {},
      curemjoy: 0, //当前表情包索引
    };
  },
  mounted() {
    switch (this.$store.state.gameType) {
      case 1://龙之国
        this.emjoylist = emjoydata.emjoylist;
        this.emjoytab = emjoydata.emjoytab;
        break;
      case 2://钢岚
        this.emjoylist = emjoydata.glEmjoylist;
        this.emjoytab = emjoydata.glEmjoytab;
        break;
      case 3://第七史诗
        this.emjoylist = emjoydata.dqssEmjoylist;
        this.emjoytab = emjoydata.dqssEmjoytab;
        break;
      default:
        break;
    }
    console.log('this.emjoylist', this.emjoylist);
  },
  methods: {
    deleteClick() {
      this.$emit("deleteClick");
    },
    emjoytabClick(id) {
      //表情包tab点击
      this.curemjoy = id;
      console.log(id);
      this.$refs.uploadswip.swipeTo(id);
    },
    //表情包功能模块
    handleSelection() {
      this.selection = getSelection();
      // 光标对象
      this.range = this.selection.getRangeAt(0);
      // 获取光标对象的范围界定对象
      this.textNode = this.range.startContainer;
      // 获取光标位置
      this.rangeStartOffset = this.range.startOffset;
    },
    emjoyGtouchstart(item) {
      //表情包长按开始
      return;
      var self = this;
      this.emjoTime = setTimeout(function () {
        self.expressionTip = item;
      }, 500); //这里设置定时器，定义长按500毫秒触发长按事件
    },
    emjoyDeleteButton(item) {
      //表情包长按手指离开
      let _this = this;
      //   clearTimeout(this.emjoTime);
      //   this.expressionTip = {};
    },
    emjoyClickButton(item) {
      this.$emit("pushvalue", item);
    },
    changeValue(emjoy) {
      console.log(emjoy);
      //评论内容表情包转换
      let str;
      let srcArr
      switch (this.$store.state.gameType) {
        case 1://龙之国
          srcArr = emjoy.gifSrc.split("emjoy")[1].split("/");
          break;
        case 2://钢岚
          srcArr = emjoy.gifSrc.split("gl")[1].split("/");
          break;
        case 3://第七史诗
          srcArr = emjoy.gifSrc.split("dqss")[1].split("/");
          break;
        default:
          break;
      }
      //获取图片地址
      let id = `${srcArr[2].split(".")[0]}`;
      this.emjoytab.forEach((item, index) => {
        if (srcArr[1] == item.name) {
          if (id.charAt(0) == "0") {
            str = `[${emjoy.class}_${emjoy.name}_${item.id}_${srcArr[2].split(".")[0]}]`;
          } else {
            str = `[${emjoy.class}_${emjoy.name}_${item.id}_${srcArr[2].split(".")[0]}]`;
          }
        }
      })
      return str;
    },
  },
};
</script>